var _style, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAnoloader(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 187 185",
    style: {
      animation: "1s linear infinite both a0_o"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n@keyframes a0_o { 0% { opacity: 1; animation-timing-function: cubic-bezier(.4,0,1,1); } 50% { opacity: .6; animation-timing-function: cubic-bezier(0,0,.6,1); } 100% { opacity: 1; } }\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#f4f7fb",
    fillRule: "evenodd",
    d: "M93.1 0c27.6 0 50 9 67.9 26.7c17.1 17.8 25.7 39.4 25.9 65.2v.8v85.3c0 .5-0.1 .9-0.2 1.4c-0.8 2.1-3.1 3.3-5.2 2.6h-0.2l-35-12.1c-14.8 9.6-32.5 14.7-53.2 14.7c-26.9 0-49.3-9-67.2-26.7c-17.3-17.7-25.9-39.5-25.9-65.2c0-26.1 8.6-48 25.9-66c17.9-17.7 40.3-26.7 67.2-26.7Zm.7 42.1c-27.4 0-49.7 22.3-49.7 49.8c0 27.6 22.3 49.9 49.7 49.9c27.4 0 49.7-22.3 49.7-49.9c0-27.5-22.3-49.8-49.7-49.8Zm0 17.6c17.8 0 32.2 14.4 32.2 32.2c0 17.9-14.4 32.3-32.2 32.3c-17.8 0-32.2-14.4-32.2-32.3c0-17.8 14.4-32.2 32.2-32.2Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnoloader);
export default __webpack_public_path__ + "static/media/anoloader.4927375f.svg";
export { ForwardRef as ReactComponent };